import { fnUtils } from './fnUtils.js';

/**
 *  Запрещает каретке становиться за указанные границы
 */
function caretGuard(guard) {
    return function (element) {
        var document = element.ownerDocument;
        var isPointerDown = 0;
        var onPointerDown = function () { return isPointerDown++; };
        var onPointerUp = function () {
            isPointerDown = Math.max(--isPointerDown, 0);
        };
        var listener = function () {
            if (document.activeElement !== element) {
                return;
            }
            if (isPointerDown) {
                document.addEventListener('mouseup', listener, {
                    once: true,
                    passive: true,
                });
                return;
            }
            var start = element.selectionStart || 0;
            var end = element.selectionEnd || 0;
            var _a = guard(element.value, [start, end]), fromLimit = _a[0], toLimit = _a[1];
            if (fromLimit > start || toLimit < end) {
                element.setSelectionRange(fnUtils.clamp(start, fromLimit, toLimit), fnUtils.clamp(end, fromLimit, toLimit));
            }
        };
        document.addEventListener('selectionchange', listener, { passive: true });
        element.addEventListener('mousedown', onPointerDown, { passive: true });
        document.addEventListener('mouseup', onPointerUp, { passive: true });
        return function () {
            document.removeEventListener('selectionchange', listener);
            document.removeEventListener('mousedown', onPointerDown);
            document.removeEventListener('mouseup', onPointerUp);
        };
    };
}
/**
 *  Запрещает удалять указанный префикс
 */
function prefixPostprocessor(prefix) {
    return prefix
        ? function (_a, initialElementState) {
            var value = _a.value, selection = _a.selection;
            if (value.startsWith(prefix) ||
                (!value && !initialElementState.value.startsWith(prefix))) {
                return { value: value, selection: selection };
            }
            var from = selection[0], to = selection[1];
            var requiredPrefix = Array.from(prefix).reduce(function (computedPrefix, char, i) {
                var newValue = computedPrefix + value;
                return newValue[i] === char ? computedPrefix : computedPrefix + char;
            }, '');
            return {
                selection: [from + requiredPrefix.length, to + requiredPrefix.length],
                value: requiredPrefix + value,
            };
        }
        : function (state) { return state; };
}
var countDigits = function (value) { return value.replace(/\D/g, '').length; };
/**
 * Препроцессор необходим для правильной вставки/автокомплита телефонного номера
 */
function insertionPhonePreprocessor(mask, countryCode, clearableCountryCode) {
    var completePhoneLength = mask.filter(function (item) { return "".concat(item) === "".concat(/\d/) || /[0-9]/.test("".concat(item)); }).length;
    var trimCountryPrefix = function (value) {
        if (countryCode === '7') {
            return value.replace(/^(\+?7?\s?8?)\s?/, '');
        }
        return value.replace(new RegExp("^(\\+?".concat(countryCode, "?)\\s?")), '');
    };
    return function (_a) {
        var elementState = _a.elementState, data = _a.data;
        var value = elementState.value, selection = elementState.selection;
        var valueDigitsCount = countDigits(value);
        var nextData;
        if (clearableCountryCode) {
            var fullNumberSelected = value.replace('+', '').length <= selection[1] - selection[0];
            if (valueDigitsCount > 0 && !fullNumberSelected) {
                nextData =
                    countDigits(data) >= completePhoneLength ? trimCountryPrefix(data) : data;
            }
            else {
                nextData = countDigits(data) > completePhoneLength ? trimCountryPrefix(data) : data;
            }
        }
        else {
            nextData = countDigits(data) >= completePhoneLength ? trimCountryPrefix(data) : data;
        }
        return {
            data: nextData,
            elementState: {
                selection: selection,
                value: valueDigitsCount > completePhoneLength ? trimCountryPrefix(value) : value,
            },
        };
    };
}
/**
 * Препроцессор необходим для сохранения кода страны при автозаполнении
 */
function preserveCountryCodePreprocessor(countryCode, preserveCountryCode) {
    return function (_a) {
        var elementState = _a.elementState, data = _a.data;
        if (!preserveCountryCode || fnUtils.isNil(countryCode)) {
            return { elementState: elementState, data: data };
        }
        var value = elementState.value, selection = elementState.selection;
        if (value.length > 0 && !value.startsWith('+')) {
            var nextValue = countryCode.concat(value);
            return {
                elementState: {
                    value: nextValue,
                    selection: selection,
                },
            };
        }
        return { elementState: elementState };
    };
}
var maskUtils = {
    insertionPhonePreprocessor: insertionPhonePreprocessor,
    prefixPostprocessor: prefixPostprocessor,
    caretGuard: caretGuard,
    preserveCountryCodePreprocessor: preserveCountryCodePreprocessor,
};

export { maskUtils };
